const LOCALE = "locale";
const LANGUAGE = "language";

export const dataLocalStorage = {
  setLocale(locale) {
    localStorage.setItem(LOCALE, locale);
  },
  getLocale() {
    return localStorage.getItem(LOCALE);
  },
  setLanguage(language) {
    localStorage.setItem(LANGUAGE, language);
  },
  getLanguage() {
    return localStorage.getItem(LANGUAGE);
  },
};
